export function prettyPrintAndStringifyLargeNumber(val: number) {
  try {
    if (typeof val !== 'number') throw new Error()

    if (val < 1000) return val.toString()
    if (val < 1000000) return `${(val / 1000).toFixed(1)}k`
    if (val < 1000000000) return `${(val / 1000000).toFixed(1)}m`
    return `${(val / 1000000000).toFixed(1)}b`
  } catch (error) {
    return val?.toString()
  }
}
